import styled from 'styled-components';

const ResourceLink = styled.div`
  font-size: ${props => props.small && '0.9em'};
  margin-left: ${props => props.inline ? '25px' : '0px'};
  text-decoration: none;
  color: #669933;
  cursor: pointer;
  max-width: 500px;
  
  &:hover {
    text-decoration: underline;
    background-color: #dfead2;
  }
`;

export default ResourceLink;
